import { SxProps, Theme } from '@mui/material';

export const reportDataGridSx: SxProps<Theme> = {
    border: '1px solid #e0e0e0',
    '& .MuiDataGrid-columnHeaders': {
        backgroundColor: '#f5f5f5',
        fontWeight: 600,
    },
    '& .MuiDataGrid-row:hover': {
        backgroundColor: '#fafafa',
    },
    '& .MuiDataGrid-cell:hover': {
        color: '#d40029',
    },
    '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within': {
        outline: '1px solid #d40029',
        outlineOffset: '-1px',
    },
    '& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within': {
        outline: '1px solid #d40029',
        outlineOffset: '-1px',
    },
};